export const GARMENTS = [
  {
    key: "tshirt",
    label: "Camiseta",
    front: "/garments/tshirt-front.png",
    back: "/garments/tshirt-back.png",
    area: { cx: 0.5, cy: 0.42, w: 0.32 },
  },
  {
    key: "hoodie",
    label: "Sudadera",
    front: "/garments/hoodie-front.png",
    back: "/garments/hoodie-back.png",
    area: { cx: 0.5, cy: 0.52, w: 0.28 },
  },
  {
    key: "cap",
    label: "Gorra",
    front: "/garments/cap-front.png",
    back: "/garments/cap-back.png",
    area: { cx: 0.5, cy: 0.42, w: 0.22 },
  },
  {
    key: "mug",
    label: "Taza",
    front: "/garments/mug-front.png",
    back: "/garments/mug-back.png",
    area: { cx: 0.46, cy: 0.5, w: 0.28 },
  },
  {
    key: "tote",
    label: "Tote bag",
    front: "/garments/tote-front.png",
    back: "/garments/tote-back.png",
    area: { cx: 0.5, cy: 0.52, w: 0.4 },
  },
];

export const COLORS = [
  { name: "Blanco", value: "#FFFFFF" },
  { name: "Negro", value: "#1A1A1A" },
  { name: "Marino", value: "#1E293B" },
  { name: "Azul Klein", value: "#002FA7" },
  { name: "Rojo", value: "#B91C1C" },
  { name: "Verde bosque", value: "#14532D" },
  { name: "Mostaza", value: "#CA8A04" },
  { name: "Gris jaspe", value: "#9CA3AF" },
  { name: "Rosa", value: "#EC4899" },
  { name: "Arena", value: "#D8C4A5" },
];

export const getGarment = (key) => GARMENTS.find((g) => g.key === key) || GARMENTS[0];
